import {TimeUtils, UuidUtils} from '@vdw/angular-component-library';
import {DateTime, Duration} from 'luxon';
import {Shift} from '../shift/shift';
import {BreakTime} from './break-time';

export class PatternShift {
  private _id: number | string;
  private _dayIndex: number;
  private _sequence: number;
  private _occurrenceOfShift: number;
  private _shift: Shift;
  private _startTime: Duration;
  private _endTime: Duration;
  private _breakTimes: BreakTime[];
  private _originalSequence: number;
  private _isOvernight: boolean;

  public constructor(
    id: number | string,
    dayIndex: number,
    shift: Shift,
    startTime: Duration,
    endTime: Duration,
    breakTimes: BreakTime[] = [],
    sequence?: number,
    occurrenceOfShift?: number,
    originalSequence?: number,
    isOvernight?: boolean
  ) {
    this._id = id;
    this._dayIndex = dayIndex;
    this._sequence = sequence;
    this._occurrenceOfShift = occurrenceOfShift;
    this._shift = shift;
    this._startTime = startTime;
    this._endTime = endTime;
    this._breakTimes = breakTimes;
    this._originalSequence = originalSequence;
    this._isOvernight = isOvernight;
  }

  public get id(): number | string {
    return this._id;
  }

  public set id(value: number | string) {
    this._id = value;
  }

  public get dayIndex(): number {
    return this._dayIndex;
  }

  public set dayIndex(value: number) {
    this._dayIndex = value;
  }

  public get sequence(): number {
    return this._sequence;
  }

  public set sequence(value: number) {
    this._sequence = value;
  }

  public get occurrenceOfShift(): number {
    return this._occurrenceOfShift;
  }

  public set occurrenceOfShift(value: number) {
    this._occurrenceOfShift = value;
  }

  public get shift(): Shift {
    return this._shift;
  }

  public set shift(value: Shift) {
    this._shift = value;
  }

  public get startTime(): Duration {
    return this._startTime;
  }

  public set startTime(value: Duration) {
    this._startTime = value;
  }

  public get endTime(): Duration {
    return this._endTime;
  }

  public set endTime(value: Duration) {
    this._endTime = value;
  }

  public get breakTimes(): BreakTime[] {
    return this._breakTimes;
  }

  public set breakTimes(value: BreakTime[]) {
    this._breakTimes = value;
  }

  public get originalSequence(): number {
    return this._originalSequence;
  }

  public get isOvernight(): boolean {
    return this._isOvernight;
  }

  public static fromJSON(patternShiftJSON: any): PatternShift {
    return new PatternShift(
      patternShiftJSON.id,
      patternShiftJSON.dayIndex,
      Shift.fromJSON(patternShiftJSON.shift),
      TimeUtils.convertTimeSpanToDuration(patternShiftJSON.startTimeFromMidnight),
      TimeUtils.convertTimeSpanToDuration(patternShiftJSON.endTimeFromMidnight),
      patternShiftJSON.breakTimes?.map((breakTimeJSON: any) => BreakTime.fromJSON(breakTimeJSON)),
      patternShiftJSON.sequence,
      patternShiftJSON.occurrenceOfShift
    );
  }

  public static fromPreviewJSON(patternShiftJSON: any, startDate: DateTime): PatternShift {
    return new PatternShift(
      UuidUtils.generateV4Uuid(),
      undefined,
      Shift.fromJSON(patternShiftJSON.shift),
      DateTime.fromISO(patternShiftJSON.start).diff(startDate, ['days', 'hours', 'minutes']),
      DateTime.fromISO(patternShiftJSON.end).diff(startDate, ['days', 'hours', 'minutes']),
      patternShiftJSON.breakTimes?.map((breakTimeJSON: any) => BreakTime.fromPreviewJSON(breakTimeJSON, startDate)),
      undefined,
      undefined,
      patternShiftJSON.originalSequence,
      patternShiftJSON.isOvernight
    );
  }

  public toJSON(): JSON {
    return {
      id: typeof this._id === 'number' ? this._id : undefined,
      dayIndex: this._dayIndex,
      shiftId: this._shift?.id,
      startTimeFromMidnight: this._startTime?.toFormat('d:hh:mm:ss'),
      endTimeFromMidnight: this._endTime?.toFormat('d:hh:mm:ss'),
      breakTimes: this._breakTimes.map((breakTime: BreakTime) => breakTime.toJSON()),
      sequence: this._sequence,
      occurrenceOfShift: this._occurrenceOfShift
    } as any as JSON;
  }
}
